/**
 * Created by ashahab on 8/19/2017.
 */
import React, { Component } from "react";
import { connect } from "react-redux";
import SelectFieldGroup from "../../../forms/select-field-group";
import { browserHistory } from "react-router";
import interactiveIcon from '../../../../assets/images/interactive.png';

class WidgetOpenAssignments extends Component {

    constructor(props) {
        super(props);

        this.headinText = props.headinText;
        this.style = { backgroundColor: 'blue' };
        this.state = { selectedFilter: '', sortByDropDown: '' };
    }

    getAssignmentClass(record) {
        let className = 'minnine ';
        let assignType = record.assignmentType ? record.assignmentType.toLowerCase() : 'learning';
        if (assignType === 'course') {

            className += 'booksRow';
        } else if (assignType === 'activity') {
            let type = record.activityType ? record.activityType.toLowerCase() : '';

            switch (type) {
                case 'url':
                case 'pdf':
                case 'learning':
                    className += 'learning';
                    break;
                case 'question':
                case 'questions':
                    className += 'questionRow';
                    break;
                case 'flashcard':
                case 'flashcards':
                    className += 'flashCard';
                    break;
            }
        } else {
            className += 'learning';
        }
        return className;
    }

    render() {


        let allFilters = this.props.dataForFilter ? this.props.dataForFilter : [];
        var d = new Date();
        var timestamp = Math.floor(d.getTime());
        if (allFilters.length > 0) {
            allFilters.forEach(filter => {
                delete filter.count;
                filter.id = filter.name;
            });
        }

        let allDataHtml = [];
        let allData = this.props.data;
        if (allData && allData.length > 0) {
            let results1 = [];
            allData.forEach(item => {
                if (item.assignedActivities && item.assignedActivities.timeStampEnd && item.assignedActivities.timeStampEnd < timestamp) { item.assignmentStatus = "Locked" }
                else if (item.assignedCourses && item.assignedCourses.timeStampEnd && item.assignedCourses.timeStampEnd < timestamp) { item.assignmentStatus = "Locked" }
                if (item.assignedActivities && item.assignedActivities.timeStampStart && item.assignedActivities.timeStampStart > timestamp) { }
                else if (item.assignedCourses && item.assignedCourses.timeStampStart && item.assignedCourses.timeStampStart > timestamp) { }
                else { results1.push(item) }
            });
            allData = results1
            allData.forEach(data => {
                var d = new Date();
                var timestamp = Math.floor(d.getTime());
                let rawDate = new Date(parseFloat(data.dueDate));
                let dueDate = (rawDate.getUTCMonth() + 1) + '/' + rawDate.getUTCDate() + '/' + rawDate.getUTCFullYear();
                let assignedDate = new Date(parseFloat(data.createdAt));
                let createdAt = (assignedDate.getUTCMonth() + 1) + '/' + assignedDate.getUTCDate() + '/' + assignedDate.getUTCFullYear();
                let progress = 0;
                if (data.progress) {
                    progress = data.progress.toString().split('%');
                }

                allDataHtml.push(
                    <div key={Math.random()}>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12  " onClick={() => { 
                            if(data.assignedActivities && data.assignedActivities.assessmentType == "Interactive"){
                                if (data.assignmentStatus == "Open") {
                                  return browserHistory.push({
                                    pathname:
                                      "/assignments/interactive/" +
                                      data.assignmentID +
                                      "/" +
                                      data.assignmentName,
                                  });
                                } else {
                                    return;
                                }
                            }
                            browserHistory.push('/student/assignments/view/' + data.assignmentID) 
                        }}
                            style={{ cursor: 'pointer' }}>
                            <div className="icondes">
                                <div className="limitFiltersas">
                                    {(!data.assignedActivities || data.assignedActivities.assessmentType != 'Interactive') && <span className={this.getAssignmentClass(data)} />}
                                    {data.assignedActivities && data.assignedActivities.assessmentType == 'Interactive' && <span className="typeIcon interactiveIcon"> 
                                        <img className="main-icon" src={interactiveIcon} />
                                    </span>
                                    }
                                </div>
                            </div>
                            <div className="icondeshead">
                                <a className="boardhead" >{data.assignmentName}</a>
                                <a className="boardheadgrey" >Date Assigned : {createdAt}</a>
                                <a className="boardheadgrey" >Due Date : {dueDate}</a>
                                <a className="boardheadgrey" >Teacher : {data.teacher}</a>
                                <div className="col-lg-5 col-md-6 col-sm-6 col-xs-6 text-alignlft paddnone" />
                            </div>
                            <div className="icondesheadsel">
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12   barchrtlghtblde">
                                    <div className="filled" style={{ width: parseFloat(progress[0]) + '%' }} />
                                    {(parseFloat(progress[0])) > 0 ? (parseFloat(progress[0]).toFixed(2) + ' %') : 'Not Started'}
                                </div>
                            </div>
                        </div>
                        <div className="brdrds" />
                    </div>
                );
            });
        }
        let that = this;
        return (

            <div className="dasboxss col-lg-5 col-md-6 col-sm-6 col-xs-12" style={{ marginBottom: '0px', paddingBottom: '0px' }}>
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12  pacboxdes" style={{ marginBottom: '0px' }}>
                    <div>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12  ">
                            <div className="icondes" style={{ marginLeft: '-10px', marginRight: '5px', width: '49px' }}>
                                <div className="limitFiltersas">
                                    <span className="typeIconsorn minnine" />
                                </div>
                            </div>
                            <div className="icondeshead" style={{ width: '31%' }}>
                                <a className="boardheadblf" href="#">{that.headinText}</a>
                            </div>
                            <div className="float-lft" style={{ marginRight: '5px' }}>
                                <SelectFieldGroup
                                    field={that.headinText.toString().trim().toLowerCase()}
                                    options={allFilters}
                                    value={this.state.selectedFilter}
                                    onChange={function (e) {
                                        that.setState({ selectedFilter: e.target.value });
                                        that.props.onFilterChangeHandler(e);
                                    }}
                                    placeholder={that.props.filterPlaceHolder}
                                />
                            </div>
                            <div className="float-lft">
                                <SelectFieldGroup
                                    isDisabled={false}
                                    field="sortByDropDown"
                                    value={this.state.sortByDropDown}
                                    options={[{ id: 'dueDate', name: 'Due Date' }, { id: 'createdAt', name: 'Date Assigned' }]}
                                    onChange={(evt) => {
                                        this.setState({ sortByDropDown: evt.target.value });
                                        this.props.onSortingChangeHandler(evt);
                                    }}
                                />
                            </div>
                            {/*<div className="icondesheadsel">*/}

                            {/*</div>*/}
                        </div>
                        < div className="brdrds" />
                    </div>
                    <div className="dashboardWidgetContainer">
                        {that.props.data && allDataHtml}
                    </div>
                    <div>
                        <a className="lsthed" href="#" onClick={that.props.onClickViewAll}>View Past Assignments</a>
                    </div>
                </div>
            </div>
        );
    }
}


function mapStateToProps(state = {}) {
    return { ...state };
}

export default connect(mapStateToProps)(WidgetOpenAssignments);
